import { useState } from "react";
import styles from "./rolesPermissions.module.css";

// Picks the roles this role's admins may give ("يمكنه تعيين"). `options` are
// the role names that can be picked, in display order.
const ManageRolesEditor = ({ options, selected, busy, onSave, onCancel }) => {
  const [picked, setPicked] = useState(() => new Set(selected));
  const changed = picked.size !== selected.length || selected.some((name) => !picked.has(name));

  const toggle = (name) =>
    setPicked((previous) => {
      const next = new Set(previous);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return next;
    });

  return (
    <div className={styles.manageEditor}>
      <div className={styles.chips}>
        {options.map((name) => (
          <button
            key={name}
            type="button"
            className={`${styles.chipToggle} ${picked.has(name) ? styles.chipToggleOn : ""}`}
            aria-pressed={picked.has(name)}
            onClick={() => toggle(name)}
            disabled={busy}
            dir="ltr"
          >
            {name}
          </button>
        ))}
      </div>
      <div className={styles.manageActions}>
        <button type="button" className={styles.ghostBtn} onClick={onCancel} disabled={busy}>
          إلغاء
        </button>
        <button
          type="button"
          className={styles.saveBtn}
          onClick={() => onSave(options.filter((name) => picked.has(name)))}
          disabled={busy || !changed}
        >
          {busy ? "جارٍ الحفظ…" : "حفظ"}
        </button>
      </div>
    </div>
  );
};

export default ManageRolesEditor;
